import { render, staticRenderFns } from "./lastPower.vue?vue&type=template&id=5ffa62b0&scoped=true&"
import script from "./lastPower.vue?vue&type=script&lang=js&"
export * from "./lastPower.vue?vue&type=script&lang=js&"
import style0 from "./lastPower.vue?vue&type=style&index=0&id=5ffa62b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa62b0",
  null
  
)

export default component.exports